// Utilities
import { createSimpleFunctional } from '@/util'

export const VCardText = createSimpleFunctional('v-card-text')

export type VCardText = InstanceType<typeof VCardText>
